import * as Sentry from '@sentry/react'
import { addFeatureToEvent, addFeatureToRouteSpan } from './sentry-feature'

let initialized = false
export default (config, user) => {
  const { sentryDsn } = config
  if (!(process.env.NODE_ENV === 'production' && sentryDsn)) {
    return
  }

  const sentryRelease = process.env.REACT_APP_COMMIT_SHA || 'no-commit-sha'
  // Sentry requires SENTRY_RELEASE to exist even though we pass the `release` option.
  window.SENTRY_RELEASE = { id: sentryRelease }

  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: true,
    integrations: [
      // Observe browser navigation across the main router and nested subapp routers.
      Sentry.browserTracingIntegration({
        beforeStartSpan: options => {
          const spanOptions = addFeatureToRouteSpan(options)
          Sentry.setTag('feature', spanOptions.attributes.feature)
          return spanOptions
        }
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: true,
        blockAllMedia: false
      })
    ],
    tracesSampleRate: 0.25,
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: sentryRelease,
    beforeSend: addFeatureToEvent,
    beforeSendTransaction: addFeatureToEvent
  })

  if (user) {
    Sentry.setUser({username: user.name})
  }

  initialized = true
}

export const setUserInSentry = (user) => {
  if (user) {
    Sentry.setUser({username: user.name})
  }
}

export const logError = (error, extraInfo) => {
  if (initialized) {
    Sentry.withScope(scope => {
      scope.setExtras(extraInfo)
      Sentry.captureException(error)
    })
  }
}
